<template>
  <div
    :id="`scala-cell-${itemId}`"
    class="w-max cursor-pointer"
  >
    <span :class="isAllMatch ? 'text-[#34A770]' : 'text-[#F95031]'">{{ displayValue[0] }}</span>
    <span class="text-[#828282]">/</span>
    <span class="text-[#828282]">{{ displayValue[1] }}</span>

    <b-popover
      v-if="hoverDetails"
      :target="`scala-cell-${itemId}`"
      triggers="hover"
      position="top"
      custom-class="scala-popover bg-white min-w-[350px]"
    >
      <div class="grid grid-cols-[70px_10px_1fr] gap-x-2 gap-y-2 text-[14px]">
        <template v-if="hoverDetails.followers">
          <span class="text-[#4F4F4F]">Followers</span>
          <span class="text-[#4F4F4F]">:</span>
          <div>
            <span :class="getColor(hoverDetails.followers.is_match)">{{ formatNumber(hoverDetails.followers.actual) }}</span><span
              v-if="hoverDetails.followers.minimum"
              class="text-[#828282]"
            >/{{ formatNumber(hoverDetails.followers.minimum) }}</span>
          </div>
        </template>

        <template v-if="hoverDetails.gmv">
          <span class="text-[#4F4F4F]">GMV</span>
          <span class="text-[#4F4F4F]">:</span>
          <div class="wrap-anywhere">
            <span :class="getColor(hoverDetails.gmv.is_match)">{{ formatNumber(hoverDetails.gmv.actual) }}</span>
          </div>
        </template>

        <template v-if="hoverDetails.category">
          <span class="text-[#4F4F4F]">Kategori</span>
          <span class="text-[#4F4F4F]">:</span>
          <div class="wrap-anywhere">
            <span :class="getColor(hoverDetails.category.is_match)">{{ hoverDetails.category.actual }}</span>
          </div>
        </template>

        <template v-if="hoverDetails.domicile">
          <span class="text-[#4F4F4F]">Domisili</span>
          <span class="text-[#4F4F4F]">:</span>
          <div>
            <span :class="getColor(hoverDetails.domicile.is_match)">{{ hoverDetails.domicile.actual }}</span><span
              v-if="hoverDetails.domicile.minimum"
              class="text-[#828282]"
            >/{{ hoverDetails.domicile.minimum }}</span>
          </div>
        </template>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  props: {
    scala: {
      type: String,
      default: '',
    },
    hoverDetails: {
      type: Object,
      default: () => null,
    },
    /**
     * Unique identifier for the cell.
     * Used as the target ID for the b-popover to ensure the correct popover
     * is triggered for each individual cell in the table.
     */
    itemId: {
      type: [String, Number],
      default: () => Math.random().toString(36).substr(2, 9),
    },
  },
  computed: {
    displayValue() {
      if (!this.scala) return ['N', 'A']
      return this.scala.split('/')
    },
    isAllMatch() {
      if (!this.hoverDetails) return false
      return Object.values(this.hoverDetails).every(detail => detail.is_match)
    },
  },
  methods: {
    getColor(isMatch) {
      return isMatch ? 'text-[#34A770]' : 'text-[#F95031]'
    },
    formatNumber(num) {
      if (num === null || num === undefined) return ''
      const n = Number(num)
      if (Number.isNaN(n)) return num
      if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, '').replace('.', ',')}M`
      if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '').replace('.', ',')}k`
      return n
    },
    formatCurrency(num) {
      if (num === null || num === undefined) return ''
      return `Rp${this.formatNumber(num)}`
    },
    parseCategory(val) {
      try {
        const parsed = JSON.parse(val)
        if (Array.isArray(parsed)) return parsed.join(',')
        return val
      } catch (e) {
        return val
      }
    },
  },
}
</script>

<style>
/*
 * Custom styling for Bootstrap-Vue popover
 * Used in ScalaCell and Export button (Page.vue)
 */
.scala-popover {
  border-radius: 8px;
}
/* Override default arrow colors to match the brand color */
.scala-popover .arrow::after, .scala-popover .arrow::before {
  border-left-color: #F95031!important;
  border-right-color: #F95031!important;
}
</style>
